import Meta from 'src/components/meta/Meta';

const BuySuccessMeta = () => <Meta
  title="Successful Pending Buy | Property Investment | BrickX"
/>;

export default BuySuccessMeta;
